import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteCompanyResourceGroup } from '../../../../actions/task-schedule/CompanyResourceGroup';

const CompanyResourceGroupDeleteButton = ({
  dispatchDeleteCompanyResourceGroup,
  companyResourceGroupId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () =>
    dispatchDeleteCompanyResourceGroup({ companyResourceGroupId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

CompanyResourceGroupDeleteButton.propTypes = {
  dispatchDeleteCompanyResourceGroup: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  companyResourceGroupId: PropTypes.number.isRequired,
};

CompanyResourceGroupDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteCompanyResourceGroup: deleteCompanyResourceGroup,
};

export default connect(
  null,
  mapDispatchToProps,
)(CompanyResourceGroupDeleteButton);
